import { createSelector } from 'reselect';
import { getSearchAsObject } from '@shared/selectors';
import { QUERY_PARAM } from '@commons/constants';

const getOriginFromUrl = createSelector(getSearchAsObject, search =>
  search ? search[QUERY_PARAM.ORIGIN] : '',
);

export default getOriginFromUrl;
